import { inject, Injectable } from '@angular/core';

import {
  aliasesFromDisplayInfos,
  formatFormulaForDisplay,
  FormatFormulaForDisplayOptions,
} from '@blaze-shared/formulas-domain-language-grammar';
import { SchemaService } from '@blaze-shared/schema-data-access';

@Injectable({ providedIn: 'root' })
export class FormulaDisplayFormatterService {
  private readonly schemaService = inject(SchemaService);

  format(
    code: string | null | undefined,
    options: Omit<FormatFormulaForDisplayOptions, 'resolveColumnId' | 'resolveTagId'> = {},
  ): string {
    return formatFormulaForDisplay(code, {
      ...options,
      aliases: [...(options.aliases ?? []), ...aliasesFromDisplayInfos(options.displayInfos)],
      resolveColumnId: (columnId) => this.schemaService.getColumnName(columnId) || undefined,
      resolveTagId: (tagId) => this.schemaService.getTagInfo(tagId)?.value,
    });
  }
}
